import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Grove from "@/pages/Grove";
import EmergenceGarden from "@/pages/EmergenceGarden";
import RoundPermalink from "@/pages/RoundPermalink";
import LettersInbox from "@/pages/LettersInbox";
import Library from "@/pages/Library";
import Audit from "@/pages/Audit";
import Rights from "@/pages/Rights";
import About from "@/pages/About";
import Share from "@/pages/Share";
import Water from "@/pages/Water";
import ScrollToTop from "@/components/ScrollToTop";
import InstallPrompt from "@/components/InstallPrompt";
import UpdateBanner from "@/components/UpdateBanner";

const TOAST_OPTIONS = {
  style: {
    background: "#F4F1E8",
    color: "#1C241F",
    border: "1px solid #D8D3C4",
    fontFamily: "Outfit, sans-serif",
  },
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Grove />} />
          <Route path="/emergence-garden" element={<EmergenceGarden />} />
          <Route path="/round/:number" element={<RoundPermalink />} />
          <Route path="/letters" element={<LettersInbox />} />
          <Route path="/library" element={<Library />} />
          <Route path="/audit" element={<Audit />} />
          <Route path="/rights" element={<Rights />} />
          <Route path="/about" element={<About />} />
          <Route path="/share" element={<Share />} />
          <Route path="/water" element={<Water />} />
        </Routes>
      </BrowserRouter>
      <InstallPrompt />
      <UpdateBanner />
      <Toaster position="bottom-center" toastOptions={TOAST_OPTIONS} />
    </div>
  );
}

export default App;
